var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoImcFhKremsSignetSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:none;stroke:#94C11C;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -208.04,
    y1: -84.35,
    x2: 633.96,
    y2: 509.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 633.96,
    y1: -84.35,
    x2: -208.04,
    y2: 509.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 213.47,
    cy: 212.51,
    r: 190.83
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M216.07,28.16c-14.35,0-28.33,1.58-41.79,4.55c-15.92-11.2-35.32-17.78-56.27-17.78c-54.08,0-97.92,43.84-97.92,97.92 c0,17.49,4.59,33.9,12.62,48.11c-6.2,18.92-9.57,39.13-9.57,60.12c0,106.55,86.38,192.93,192.93,192.93S409,327.63,409,221.08 S322.62,28.16,216.07,28.16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.97,243.52c-11.48,11.48-30.16,11.48-41.64,0c-5-5-7.82-11.36-8.47-17.89c0,0-0.18-1.1-0.12-3.24 c0.06-1.99,0.12-2.75,0.12-2.75c0.69-6.71,3.63-12.93,8.46-17.76c11.48-11.48,30.17-11.48,41.65,0c5.09,5.09,13.34,5.09,18.43,0 c5.09-5.09,5.09-13.34,0-18.43c-21.65-21.64-56.86-21.64-78.5,0c-0.17,0.17-0.33,0.35-0.49,0.52 c-8.24-9.84-20.6-16.11-34.41-16.11c-12.44,0-23.7,5.1-31.84,13.3c-8.14-8.2-19.4-13.3-31.84-13.3c-7.83,0-15.19,2.02-21.6,5.56 c-2.51-2.97-6.28-4.87-10.5-4.87c-7.56,0-13.68,6.07-13.68,13.56V262c0,7.49,6.12,13.56,13.68,13.56 c7.56,0,13.68-6.07,13.68-13.56v-51.75c0.42-10.19,9.37-16.34,18.42-16.34c10.38,0,18.82,8.44,18.82,18.82v50.1 c0,7.19,5.83,13.02,13.02,13.02c7.19,0,13.02-5.83,13.02-13.02v-50.1c0-10.38,8.44-18.82,18.82-18.82 c10.38,0,18.82,8.44,18.82,18.82c0,0-0.18,8.54-0.18,9.97c0,0,0,0,0,0v0v0c0,14.83,5.77,28.77,16.26,39.25 c10.82,10.82,25.03,16.23,39.24,16.23c14.22,0,28.43-5.41,39.25-16.23c5.09-5.09,5.09-13.34,0-18.43 C322.31,238.43,314.06,238.43,308.97,243.52z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1602 0.1602 0.9871 -16.5533 20.3609)",
    className: "st2",
    cx: 118.01,
    cy: 112.85,
    rx: 29.39,
    ry: 29.39
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImcFhKremsSignetSquare);
export default __webpack_public_path__ + "static/media/logo-imc-fh-krems-signet-square.5102218b3f7538b9edaa4597ccaf7d44.svg";
export { ForwardRef as ReactComponent };